/* ===========================================================================
   BB FLAT FEE — count the box in the total from step 1 (2026-10-26, Moshe)
   + free-shipping progress counts the box too; the Box Summary header
     number is the Box Total, not the items subtotal (same day)
   ---------------------------------------------------------------------------
   The box fee is flat ($8 luxe, $6 mailer). The sidebar's "The Box" row
   shows "$6–$8" until a box is picked. Without this file the Box Total
   ignores the box until one is picked in step 2, so the total jumps right
   when the customer commits. With it:

     - empty box          -> Box Total $0 (no fee on nothing)
     - 1+ items, no box   -> Box Total = items + the CHEAPEST box ($6, from
                             the chrome section's box price settings), so
                             free shipping unlocked on step 1 can never be
                             lost by choosing the mailer (Moshe, Oct 26)
     - box picked (step 2)-> Box Total = items + the real box (luxe: +$2)

   Self-contained override, same pattern as bb-sizing-aplus.js: wraps
   BBPricing.summarize and re-renders. Remove its <script> line in
   snippets/bb-assets.liquid to revert. Long term this is one line in
   box-builder.js (BBPricing.summarize: `var boxPrice = selectedBoxPrice;`).
   =========================================================================== */
(function () {
  "use strict";
  if (window.__bbFlatFee) return;
  window.__bbFlatFee = true;

  function patch() {
    var pricing = window.BBPricing;
    if (!pricing || typeof pricing.summarize !== "function" || pricing.__flatFee) return !!(pricing && pricing.__flatFee);
    var orig = pricing.summarize;
    pricing.summarize = function (state) {
      var s = orig.call(this, state);
      var hasBox = !!(s && s.state && s.state.box && s.state.box.variantId);
      if (s && !hasBox && s.count > 0) {
        var est = Number(s.estimatedBoxPrice) || 0;
        s.boxPrice = est;
        s.boxTotal = (Number(s.boxTotal) || 0) + est;
      }
      /* Free shipping counts the whole box (items + box + card), the same
         subtotal Shopify applies the threshold to, not just the items. */
      var goal = Number((window.BBConfig || {}).freeShippingCents) || 0;
      if (s && goal > 0) {
        s.freeShippingRemaining = Math.max(0, goal - (Number(s.boxTotal) || 0));
        s.freeShippingUnlocked = s.freeShippingRemaining <= 0;
      }
      return s;
    };
    pricing.__flatFee = true;
    /* The big number next to "Box Summary" is the items-only subtotal in
       box-builder.js (the Goodies line already shows that). Make it the Box
       Total so it matches the bottom bar. */
    if (window.BBShell && typeof window.BBShell.render === "function" && !window.BBShell.__flatFee) {
      var origRender = window.BBShell.render;
      window.BBShell.render = function () {
        var r = origRender.apply(this, arguments);
        try {
          var s = pricing.summarize();
          var fmt = window.BBMoney && window.BBMoney.format;
          if (fmt) {
            document.querySelectorAll("[data-bb-items-total]").forEach(function (el) {
              el.textContent = fmt(s.boxTotal);
            });
          }
          /* Sidebar: size name next to "Box Size"; the $6–$8 range on The Box
             row only until a real box is chosen. */
          var tierName = (s.tier && s.tier.name) || "";
          document.querySelectorAll("[data-bb-size-name]").forEach(function (el) {
            el.textContent = s.count > 0 ? tierName : "";
          });
          var picked = !!(s.state && s.state.box && s.state.box.variantId);
          document.querySelectorAll("[data-bb-box-estimate]").forEach(function (el) {
            el.hidden = picked;
          });
        } catch (e) {}
        return r;
      };
      window.BBShell.__flatFee = true;
      try { window.BBShell.render(); } catch (e) {}
    }
    return true;
  }

  if (!patch()) document.addEventListener("DOMContentLoaded", patch);
})();